import * as yup from "yup";

const playerFormSchema = yup.object().shape({
    active: yup.number().required("Please set the player status"),
    isPrimary: yup.boolean().required(),
    firstName: yup.string().required("Player First Name is required"),
    lastName: yup.string().required("Player Last Name is required"),
    uniformNumber: yup
        .number()
        .optional()
        .nullable()
        .transform((curr, orig) => (orig === "" ? undefined : curr))
        .typeError("Invalid number"),
    dob: yup
        .string()
        .required("Player Date of Birth is required")
        .typeError("Invalid date of birth provided")
        .test("is-valid-dob", "Invalid date of birth provided", dob => {
            if (!dob) return true;
            return !isNaN(new Date(dob).getTime());
        }),
    email: yup
        .string()
        .required("Parent email is required")
        .email("Parent email is invalid"),
    positions: yup.array(
        yup.object().shape({
            value: yup.number().required(),
            label: yup.string().required(),
        }),
    ),
});

export default playerFormSchema;
